import { runEvalScript } from "..";

export async function runAfterRender(compId: number, beforeRenderState: any) {
  await runEvalScript(
    `$._blingsio.dataManager.runAfterRender(${compId}, ${JSON.stringify(beforeRenderState)})`
  );
}
